import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '@mui/material';
import { ReactComponent as ArrowIcon } from 'mui/assets/icons/arrow-right.svg';
import DS_BasicCard from 'mui/components/elements/DS_BasicCard';
import { DS_spacing as coreSpacing } from 'mui/base/theme/DS_Tokens/core';
import { LocationType } from '../../Location/Variants/types';

import { CardContent, Heading, Details, FreeParkingLabel } from './styles';

const LocationDetails = ({ data, isSelected }) => {
  const { hasFreeParking, freeParking, distanceInKm, distancePlaceholder, heading, address, phoneNumber } = data;
  return (
    <DS_BasicCard padding={coreSpacing.rem.sm}>
      <CardContent>
        <div>
          {hasFreeParking && freeParking?.heading ? (
            <div>
              <FreeParkingLabel>{freeParking.heading}</FreeParkingLabel>
            </div>
          ) : null}
          <div>
            {distanceInKm > 0 && distancePlaceholder ? (
              <Details component="p" variant="DS_copySmallRegular" data-test="booking-location-distance" isDistance>
                {distanceInKm}km {distancePlaceholder}
              </Details>
            ) : null}
          </div>

          <Heading component="p" variant="DS_copyMediumBold" isActive={isSelected} data-test="booking-location-name">
            {heading}
          </Heading>
          {process.env.GATSBY_COUNTRY_CODE !== 'de-AT' ? (
            <Details component="p" variant="DS_copySmallRegular">
              {address}
            </Details>
          ) : null}
          <Details component="p" variant="DS_copySmallRegular">
            {phoneNumber}
          </Details>
        </div>
        <div>
          <SvgIcon component={ArrowIcon} inheritViewBox={true} sx={{ fontSize: 12 }}></SvgIcon>
        </div>
      </CardContent>
    </DS_BasicCard>
  );
};

export default LocationDetails;

const DataType = PropTypes.shape({
  LocationType,
  distancePlaceholder: PropTypes.string,
});

LocationDetails.propTypes = {
  data: PropTypes.oneOfType([DataType, PropTypes.arrayOf(DataType)]),
  isSelected: PropTypes.bool,
};
